import React from 'react';
import { useAuth } from '../../auth/AuthContext';
import BackupSyncView from './BackupSyncView';

const BackupPage: React.FC = () => {
  const { user } = useAuth();
  return <BackupSyncView accountEmail={user?.userEmail?.trim() || ''} />;
};

export default BackupPage;
